import { Addons } from "src/types/stripe";
import axios from "../axios/axios";

export const getPlans = async () => {
  try {
    const { data } = await axios.get("/plans");
    return data;
  } catch (e: any) {
    throw e?.response?.data;
  }
};

export const getAddons = async () => {
  try {
    const { data } = await axios.get("/addons");
    return data;
  } catch (e: any) {
    throw e?.response?.data;
  }
};

export const checkoutPayment = async (
  productId: string,
  adminSeats: number,
  addons?: Addons
) => {
  try {
    const { data } = await axios.post("/checkout", {
      productId,
      adminSeats,
      addons,
    });
    return {
      status: data.status,
      message: data.message,
      data: data.data,
    };
  } catch (e: any) {
    console.log("error:", e);
    throw e?.response?.data;
  }
};

export const updateSubscription = async (
  productId: string,
  updateMode: string,
  adminSeats: number,
  addons?: Addons,
  promoCodes?: string[],
) => {
  const { data } = await axios.put("/updateSubscription", {
    productId,
    updateMode,
    adminSeats,
    addons,
    promoCodes,
  });
  return data;
};

export const validateCoupon = async (
  productId: string,
  total: number,
  coupon?: string
): Promise<{ 
  discount: number;
  promoCode?: string;
  error?: string 
}> => {
  try {
    const { data } = await axios.post("/validate-coupon", {
      productId,
      total,
      coupon, //could be coupon code or promocode
    });
    // console.log("data", data);
    
    return data;
  } catch (e) {
    console.log(e);
    return { discount: 0 };
  }
};

// export const updateAdminSeatPLan = async (adminCount: number) => {
//   const { data } = await axios.put("/adminSeat", { adminCount });
//   return data;
// };

export const getTenantUsage = async () => {
  try {
    const { data } = await axios.get("/getTenantUsage");
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const getTenantPayments = async () => {
  try {
    const { data } = await axios.get("/getTenantPayment");
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const getTenantPlan = async () => {
  try {
    const { data } = await axios.get("/getTenantPlan");
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const PaymentSystemService = {
  getPlans,
  checkoutPayment,
  updateSubscription,
  validateCoupon,
  // updateAdminSeatPLan,
  getTenantUsage,
  getTenantPayments,
  getTenantPlan,
  getAddons,
};

export default PaymentSystemService;
